import {
  patch,
  post,
  WEBAPP_API_URL,
  AHPLUS_API_URL,
  webappGateway,
} from 'api/ky';
import { type CurrencyCode } from 'stores/preferences/currencies';

export const cancelMembership = async () => {
  return await patch(`${AHPLUS_API_URL}/api/v2/membership/cancel`, {});
};

export const upgradeTripAnnual = async ({
  tripUuid,
  checkoutId,
  channel,
}: IUpgradeTrip) => {
  return await post(
    `${WEBAPP_API_URL}/api/ahplus/memberships/trip_upgrade`,
    {
      tripUuid,
      checkoutId,
      channel,
    },
    { kyInstance: webappGateway },
  );
};

export const applyPromoCode = async ({
  productName,
  promoCode,
  paymentIntentId,
  currency,
}: IPromoCodeRequest) => {
  return await post(`${AHPLUS_API_URL}/api/v2/promo_campaigns/apply_code`, {
    productName,
    promoCode,
    paymentIntentId,
    currency,
  });
};

export interface IPromoCodeRequest {
  productName: string;
  promoCode: string;
  paymentIntentId?: string;
  currency: CurrencyCode;
}

export interface IUpgradeTrip {
  tripUuid: string;
  checkoutId: string;
  channel: string;
}
